export const successPopupStyles = {
  position: {
    position: "fixed",
    top: "120px",
    right: "70px",
    zIndex: "100"
  }
};
